<template>
    <vx-card title="Tutoriales" code-toggler>
    <div>
      <vs-collapse type="border" accordion v-for="(item,index) in categorias" :key="index">
      <vs-collapse-item >
        <div slot="header">
          {{item.nombre}}
        </div>
        <vs-col v-for="(item2,index2) in tutoriales" :key="index2" vs-type="flex"  vs-w="6">
            <div style="width:100%" v-if="item.id == item2.categoria_id">
                <h5>#{{index2+1}} {{ item2.nombre}}</h5>
              <iframe type="text/html" width="90%" height="400" :src="item2.link" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </vs-col>
      </vs-collapse-item>
      <br>
      </vs-collapse>
    </div>
    </vx-card>
</template>
<script>
  export default {
    data () {
      return {
        tutoriales: [],
        categorias: [],
      }
    },
    methods: {
      init(){
        this.openLoading();
        this.getCategorias();
        this.getTutoriales();
      },
      openLoading(){
        this.$vs.loading({type:'corners'});
      },
      closeLoading(){
        this.$vs.loading.close();
      },
      getTutoriales() {
        this.$http.post('FB_Usuario','getVideoTutoriales',{},(data)=>{
          this.tutoriales = data;
          this.closeLoading();
        });
      }, 
      getCategorias() {
        this.$http.post('FB_Usuario','getCategorias',{},(data)=>{
          this.categorias = data;
        });
      },
    },
    mounted() {
      this.init();
    },
  }
</script>